import React, {
  useEffect, useRef, lazy, Suspense,
} from 'react';
import steps from './survey/steps';
import setupSurvey from './survey/setupSurvey';
import {
  assignOnboardingNameAbTest,
  isOnboardingNameVariantB,
} from './utils/scripts/onboardingNameAbTest';
import getParameterFromURL from './utils/scripts/getParameterFromURL';
import { getPageUrlValue, determinePaymentVersion } from './utils/scripts/analyticsTags';
import useAppLifecycle from './hooks/useAppLifecycle';
import Steps from './pages/steps';
import s from './app.module.scss';
import { useAppStore } from './store';

// Loader показывается только в самом конце воронки — не тянем его в главный бандл.
const Loader = lazy(() => import('./components/loader'));

export default function App() {
  const showSteps = useAppStore((state) => state.showSteps);
  const showLoader = useAppStore((state) => state.showLoader);
  const currentStep = useAppStore((state) => state.currentStep);
  const abGenderSentRef = useRef(false);
  const onbordingVersion = getParameterFromURL('config') ? getParameterFromURL('config') : '';

  useAppLifecycle();

  useEffect(() => {
    // Idempotent: no-op when the pre-render hydration path already set the engine up.
    setupSurvey();
  }, []);

  // Назначение группы AB-теста p20v1_onboarding_name на шаге customV2_gender.
  // В варианте B пересобираем список шагов на месте: customV2_name уезжает после
  // statement_strong_bond; setupSurvey({ rebuild: true }) пересчитывает
  // progress/header-меты и оставляет пользователя на текущем шаге.
  useEffect(() => {
    if (currentStep !== 'customV2_gender') return;
    if (abGenderSentRef.current) return;
    abGenderSentRef.current = true;
    assignOnboardingNameAbTest();

    if (isOnboardingNameVariantB()) {
      setupSurvey({ rebuild: true });
    }
  }, [currentStep]);

  useEffect(() => {
    if (!window.loadEvent) {
      const pageUrlValue = getPageUrlValue();
      const paymentVersion = determinePaymentVersion();

      // Какой HTML отдал nginx и как он загрузился (см. prerenderShell.ts):
      // prerender — гидрация статичного первого экрана;
      // prerender_fallback — pre-render файл, но откат на классический SPA-boot;
      // spa — обычный build/index.html (для конфига нет pre-render файла).
      let pageType = 'spa';
      if (window.prerenderBoot === 'hydrate') pageType = 'prerender';
      if (window.prerenderBoot === 'fallback') pageType = 'prerender_fallback';

      // additional fields for page_load
      const campaignName = getParameterFromURL('utm_campaign');
      const adGroupName = getParameterFromURL('utm_term');
      const adName = getParameterFromURL('utm_content');
      const adGroupId = getParameterFromURL('adset_id');
      const campaignId = getParameterFromURL('c_id');
      const adId = getParameterFromURL('ad_id');

      window.loadEvent = true;
      steps.analytics.send({
        event: {
          event: 'onboarding_question',
          quiz_question: 'page_load',
          quiz_answer: pageUrlValue,
          payment_type: paymentVersion,
          page_type: pageType,
          link: `${pageUrlValue}${paymentVersion}`,
          ...(campaignName ? { campaign_name: campaignName } : {}),
          ...(adGroupName ? { ad_group_name: adGroupName } : {}),
          ...(adName ? { ad_name: adName } : {}),
          ...(adGroupId ? { ad_group_id: adGroupId } : {}),
          ...(campaignId ? { campaign_id: campaignId } : {}),
          ...(adId ? { ad_id: adId } : {}),
        },
      });
      localStorage.setItem('link', `${pageUrlValue}${paymentVersion}`);
    }
  }, []);

  return (
    <div className={`${s.app} ${onbordingVersion} application`}>
      {showSteps && !showLoader && <Steps />}
      {showLoader && (
        <Suspense fallback={null}>
          <Loader />
        </Suspense>
      )}
    </div>
  );
}
